<script lang="ts">
	import { Section, type SectionTheme } from "#lib/web-ui/primitives/index.js";
	import { GlossaryOpenButton } from "./glossary";

	interface Props {
		addressLine: string;
		phoneDisplay: string;
		phoneHref: string;
		glossaryLabel: string;
		disclaimer: string;
		theme?: SectionTheme;
		id?: string;
		class?: string;
	}

	let {
		addressLine,
		phoneDisplay,
		phoneHref,
		glossaryLabel,
		disclaimer,
		theme = "dark",
		id,
		class: className
	}: Props = $props();
</script>

<Section {theme} {id} class={className} data-testid="associate-footer-disclaimer">
	<p class="text-muted-foreground text-sm">
		{addressLine} &middot;
		<a href={phoneHref} class="text-muted-foreground underline underline-offset-4">
			{phoneDisplay}
		</a>
	</p>
	<p class="mt-4 text-sm">
		<GlossaryOpenButton label={glossaryLabel} />
	</p>
	<p class="text-muted-foreground mt-4 max-w-5xl text-xs">{disclaimer}</p>
</Section>
